/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getBatchTable = params => {
  return axios.post(`${base}/query_batch`, params)
}
export const getBatchDetail = params => {
  return axios.get(`${base}/batch_${params.id}`)
}



// WEBPACK FOOTER //
// ./src/views/batch/batch.api.js